// Editable defaults offered when the auditor keeps the Form's coach for one evaluation (2026-09-25).
//
// 🔴 SUGGESTIONS, NEVER VALUES. They fill a field only when the auditor chooses "Keep the Form's
// coach" and that field is blank; whatever is typed or loaded from a saved review always wins.
//
// 🔴 THE LABEL IS A CONTEXTUAL DEFAULT, NOT A UNIQUE IDENTITY. Evaluations sharing the Form name,
// class date and Form class type get the same suggestion, and in Slice 2b identical labels within a
// franchise group as one Form-only identity. An auditor who wants several evaluations grouped
// replaces it with a shared label (e.g. "Abby 1").

export const FORM_COACH_DEFAULT_NOTE = 'No defensible Dash coach match; retained the Form-provided coach name.';

// resolved_form_coach_label NVARCHAR(120); the server rejects anything longer.
export const FORM_LABEL_MAX = 120;

// Collapses whitespace so a pasted tab or newline in a Form answer can never reach the server's
// control-character check through a suggestion.
const clean = (v) => (v === null || v === undefined ? '' : String(v).replace(/\s+/g, ' ').trim());

/**
 * `{raw Form coach name} — {class date YYYY-MM-DD} — {Form class type}`, from the evaluation's own
 * Form values only -- never from the search controls or a candidate -- so exploring cannot change it.
 * A missing segment is omitted with its separator. No Form name: no suggestion ('').
 */
export function suggestFormCoachLabel(evaluation) {
  const name = clean(evaluation && evaluation.typed_coach_name);
  if (!name) return '';
  const rawDate = clean(evaluation.class_date).slice(0, 10);
  const date = /^\d{4}-\d{2}-\d{2}$/.test(rawDate) ? rawDate : '';
  const classType = clean(evaluation.form_class_type);
  return [name, date, classType].filter(Boolean).join(' — ').slice(0, FORM_LABEL_MAX).trim();
}
